import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Estimation } from '../../models/estimation.model';
import { ProjectsList } from '../../models/projects.model';
import { Provider } from '../../models/provider.model';

@Component({
  selector: 'app-create-estimation-drawer',
  templateUrl: './create-estimation-drawer.component.html',
  styleUrl: './create-estimation-drawer.component.scss',
})
export class CreateEstimationDrawerComponent implements OnChanges {
  @Input() showEstimationDrawer = false;
  @Input() projects: any[] = [];
  @Input() selectedProject?: ProjectsList | 'all';
  @Input() companies: any[] = [];
  @Input() providers: any[] = [];
  @Input() types: any[] = [];

  @Output() closeDrawer = new EventEmitter<void>();
  @Output() searchProjects = new EventEmitter<string>();
  @Output() searchProviders = new EventEmitter<string>();
  @Output() createEstimation = new EventEmitter<Estimation>();

  createEstimationForm: any;
  unassignedProjectId = 9;
  selectedProvider!: Provider;
  isSearchingProviders = false;
  isSearchingProjects = false;

  constructor(private fb: FormBuilder) {
    this.createEstimationForm = this.fb.group({
      project: ['', [Validators.required, Validators.minLength(3)]],
      company: [{ value: '', disabled: true }],
      provider: ['', [Validators.required, Validators.minLength(3)]],
      type: [null, [Validators.required, Validators.min(0)]],
      description: ['', [Validators.required, Validators.minLength(1)]],
    });
  }

  ngOnChanges(): void {
    if (!this.isSearchingProjects) {
      this.createEstimationForm.patchValue({
        project:
          this.selectedProject === 'all'
            ? 'all'
            : this.selectedProject?.projectName || '',
      });
      this.createEstimationForm.patchValue({
        company:
          this.selectedProject && this.selectedProject !== 'all'
            ? this.selectedProject?.projectCompany
            : '',
      });
    }
    if (this.providers.length >= 0) {
      this.isSearchingProjects = false;
    }
    if (this.projects.length >= 0) {
      this.isSearchingProviders = false;
    }
  }

  close() {
    this.closeDrawer.emit();
    this.isSearchingProviders = false;
    this.createEstimationForm.reset();
    this.providers = [];
  }

  onCreateEstimation() {
    this.createEstimation.emit({
      ...this.createEstimationForm.value,
      projectID:
        this.selectedProject !== 'all' ? this.selectedProject!.projectId : null,
      supplierID: this.selectedProvider.id,
    });
  }

  onSearchProject(event: any) {
    if (!event) return;
    this.isSearchingProjects = true;
    this.searchProjects.emit(event.target.value);
  }

  onSelectProject(e: any) {
    if (!e) return;
    this.selectedProject = e.nzValue as ProjectsList;
    this.isSearchingProjects = false;
    if (this.selectedProject?.projectCompanyId === this.unassignedProjectId) {
      this.createEstimationForm.controls.company.enable();
    } else {
      this.createEstimationForm.controls.company.disable();
      this.createEstimationForm.patchValue({
        company: this.selectedProject?.projectCompany,
      });
    }
  }

  onSearchProvider(event: any) {
    this.providers = [];
    if (!event || event.target.value.length < 3) {
      return;
    }
    this.isSearchingProviders = true;
    this.searchProviders.emit(event.target.value);
  }

  onSelectProvider(e: any) {
    if (!e) return;
    this.selectedProvider = e.nzValue as Provider;
    this.createEstimationForm.patchValue({
      provider: this.selectedProvider.providerLegalName,
    });
    this.providers = [];
  }
}
